import { ColumnsFactory } from "../../../../../../shared/Components/Grid/functions";

export const getColumnDefs = () => {
  return [
    ColumnsFactory.TextColumn("Vehículo", "vehiculo"),
    ColumnsFactory.TextColumn("Auxiliar", "auxiliar"),
    ColumnsFactory.BooleanColumn("Activo", "activo"),
    ColumnsFactory.TextColumn("Codigo", "codigo"),
    ColumnsFactory.TextColumn("Comentario", "comentario")
  ];
};
